export default __webpack_public_path__ + "static/airbnb-9-ee9f1ab672c3c6b646f31170af15349a.png";